import clsx from 'clsx';

import Icon from '../Icon';

type CollapserIconProps = {
  show?: boolean;
  onClick?: () => void;
};

export const CollapserIcon: React.FC<CollapserIconProps> = ({
  show,
  onClick,
}) => {
  return (
    <Icon
      icon="caretdown"
      onClick={onClick}
      className={clsx(
        'transition-transform',
        show ? 'rotate-180' : '',
        'text-small'
      )}
    />
  );
};
